import { render, staticRenderFns } from "./home-brands.vue?vue&type=template&id=42796601"
import script from "./home-brands.vue?vue&type=script&lang=js"
export * from "./home-brands.vue?vue&type=script&lang=js"
import style0 from "./home-brands.vue?vue&type=style&index=0&id=42796601&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports